// src/pages/orders/revenueBridgePage.js
//
// Hosts the revenue bridge: sync health first, then the reconciliation from gross
// to net. Exists because the API has served this data for a while and nothing in
// the dashboard read it — so both the staleness signal and the explanation of why
// revenue is lower than gross were invisible to anyone using the product.
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody } from "../../components/card/card.jsx";
import { fetchRevenueBridge } from "../../actions/revenue_bridge_actions";
import RevenueBridgePanel from "../../components/revenue/RevenueBridgePanel";

const RANGES = [
  { label: "Today", value: "today" },
  { label: "Last 7 days", value: "last7d" },
  { label: "Last 30 days", value: "last30d" },
  { label: "Last 90 days", value: "last90d" },
];

export default function RevenueBridgePage() {
  const dispatch = useDispatch();
  const [range, setRange] = useState("last30d");
  // Order-date vs refund-date. Both are legitimate and answer different questions
  // ("what did this month's orders end up worth" vs "what money moved this
  // month"), so it is a visible choice rather than a hidden assumption.
  const [refundBasis, setRefundBasis] = useState("order");

  const { data, loading, error } = useSelector((s) => s.revenueBridge || {});

  useEffect(() => {
    dispatch(fetchRevenueBridge({ range, currency: "USD", refundBasis }));
  }, [dispatch, range, refundBasis]);

  return (
    <>
      <h1 className="page-header">
        Revenue bridge <small>how gross becomes net</small>
      </h1>

      <Card>
        <CardBody>
          <div className="d-flex flex-wrap gap-3 align-items-center mb-3">
            <div>
              <label className="form-label small mb-1">Range</label>
              <select
                className="form-select form-select-sm"
                value={range}
                onChange={(e) => setRange(e.target.value)}
              >
                {RANGES.map((r) => (
                  <option key={r.value} value={r.value}>{r.label}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="form-label small mb-1">Refunds counted by</label>
              <select
                className="form-select form-select-sm"
                value={refundBasis}
                onChange={(e) => setRefundBasis(e.target.value)}
              >
                <option value="order">Order date</option>
                <option value="refund">Refund date</option>
              </select>
            </div>
          </div>

          <RevenueBridgePanel data={data} loading={loading} error={error} />
        </CardBody>
      </Card>
    </>
  );
}
